export default __webpack_public_path__ + "static/media/filtericon.696beffa.svg";